(function () {
  if (window.__kiBadgeInit) return;
  window.__kiBadgeInit = true;

  document.addEventListener(
    'click',
    function (event) {
      var badge = event.target.closest('.ki-badge');
      if (badge) {
        event.stopPropagation();
        document.querySelectorAll('details.ki-badge[open]').forEach(function (openBadge) {
          if (openBadge !== badge) openBadge.removeAttribute('open');
        });
        return;
      }
      document.querySelectorAll('details.ki-badge[open]').forEach(function (openBadge) {
        openBadge.removeAttribute('open');
      });
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details.ki-badge[open]').forEach(function (openBadge) {
      openBadge.removeAttribute('open');
    });
  });
})();
